import {
    findCurrUser,
    getUserAllTenants,
    getAllResources,
    querySupplierInFoBySupplierCode,
    getUserRoleLists
    // fetchSystemSwitch
} from '@/api/userApi';
import lang from '@/lang/index';
import config from '@/config/user.env';
import { lcpMessage as Message } from '@/components/lots/lcpMessage.js';
import { alertErrorAndLogout, checkAndAlertError } from '@/utils/index.js';
import uploadList from './themes/UploadList';
import tenant from './themes/Tenant';
import Msg from './themes/Msg';
import App from './themes/App';
import cookies from 'js-cookie';
const whiteList = ['/mipIframe?', '/resourceApplication?', '/registractionFlow?', '/incomeSharingRules', '/goalManage'];
function containsAnyKeywordIndexOf(str, keywords) {
    return keywords.some(keyword => str.indexOf(keyword) !== -1);
}
function getResourceIds(v) {
    const RESOURCE_TYPE_MENU = 3;
    const tempArr = [];
    getId(v);

    function getId(v) {
        v.forEach(item => {
            if (+item.resourceType === RESOURCE_TYPE_MENU && item.resourceId) {
                tempArr.push(item.resourceId);
            } else if (item.subResources) {
                getId(item.subResources);
            }
        });
    }
    return tempArr;
}

export default {
    state: {
        user: {},
        authority: '',
        appId: config.appId,
        lang: {},
        tenantInfo: {},
        currentTenant: {},
        currentApplicationCode: '',
        btnPermissions: null,
        supplier: {},
        locale: '',
        langInfo: {},
        switchs: [],
        vue2MicroRoot: '',
        lotsUIEventInstance: '',
        contractManageParams: {}, // 合同-其他变更代办参数
        registrationReprotList: [], // 续签合同退出流程参数
        customerWhiteList: [], // 客户管理白名单审批流程参数
        iflowPage: { pageTime: 0 }, // 审批页当前时间戳, 用于判断多个审批页同时存在时,通信调用了不同页签的方法导致提交审批异常(多次提交导致链接异常)
        homeSearchInput: '', // 首页头部查询输入
        hasHomePage: false,
        homePageParams: {}, // 首页切换页面顶部记录参数
        userRoleList: {}, // 用户角色列表
        homeContractCode: '', // 临时处理首页跳转参数, 后期看看params 链接跳转
        ...tenant.state,
        ...Msg.state,
        ...uploadList.state,
        ...App.state
    },
    getters: {
        user: state => state.user,
        appId: state => state.appId,
        authority: state => state.authority,
        menus: state => {
            if (state.authority) {
                return state.authority;
            }
            return [];
        },
        lang: state => state.lang,
        tenantInfo: state => state.tenantInfo,
        currentTenant: state => state.currentTenant,
        btnPermissions: state => state.btnPermissions,
        applicationCode: state => {
            const currentPath = state.appList.find(item => {
                if (item.applicationDomain) {
                    return item.applicationDomain.indexOf(window.location.pathname) >= 0;
                }
                return false;
            });
            return currentPath ? currentPath.applicationCode : '';
        },
        supplier: state => state.supplier,
        locale: state => state.locale,
        langInfo: state => state.langInfo,
        systemSwitchs: state => state.switchs,
        vue2MicroRoot: state => state.vue2MicroRoot,
        lotsUIEventInstance: state => state.lotsUIEventInstance,
        contractManageParams: state => state.contractManageParams,
        registrationReprotList: state => state.registrationReprotList,
        customerWhiteList: state => state.customerWhiteList,
        iflowPage: state => state.iflowPage,
        homeSearchInput: state => state.homeSearchInput,
        hasHomePage: state => state.hasHomePage,
        homePageParams: state => state.homePageParams,
        userRoleList: state => state.userRoleList,
        homeContractCode: state => state.homeContractCode,
        ...tenant.getters,
        ...Msg.getters,
        ...uploadList.getters,
        ...App.getters
    },
    mutations: {
        getBtnPermissions(state, btnPermissions) {
            state.btnPermissions = btnPermissions;
        },
        updateUserInfo(state, user) {
            state.user = user;
        },
        updateAuthority(state, authority) {
            const isHomePage = authority.find(it => it.frontUrl === '/index');

            if (!isHomePage) {
                const homePage = {
                    'appLists': [
                        1
                    ],
                    'appType': 1,
                    'asc': ' asc',
                    'deleteFlag': 0,
                    'extendAttr1': '',
                    'frontUrl': '/index',
                    'id': 173222,
                    'orderBy': '1',
                    'orderByType': 'asc',
                    'pageSize': 30,
                    'parentCode': 'APP202304140001',
                    'remark': '',
                    'resourceCode': 'reIndex',
                    'resourceName': '首页',
                    'resourceType': 2,
                    'resourceUrl': 'icon-chengpei-kongzhitai',
                    'sensitive': 0,
                    'sortNo': 0,
                    'start': 0,
                    'version': 0
                };
                authority = [homePage, ...authority];
            }
            state.hasHomePage = !!isHomePage;
            state.authority = authority;
        },
        updateLang(state, _lang) {
            state.lang = _lang;
        },
        updateTenant(state, _tenantInfo) {
            state.tenantInfo = _tenantInfo;
        },
        updateCurrenTenant(state, _tenantInfo) {
            state.currentTenant = _tenantInfo;
        },
        updateCurrentApplicationCode(state, applicationCode) {
            state.currentApplicationCode = applicationCode;
        },
        updateSupplier(state, supplier) {
            state.supplier = supplier;
        },
        updateLangInfo(state, LangInfo) {
            state.langInfo = LangInfo;
        },
        updateLocale(state, locale) {
            // 设置接口的cookie
            cookies.set('lang', locale, { domain: '.midea.com' });
            // 设置时区
            var d = new Date();
            var gmtHours = d.getTimezoneOffset() / 60;
            gmtHours = -gmtHours;
            let sign = '+';
            if (gmtHours < 0) {
                sign = '-';
            }
            const numLength = 2; // 数字长度 前面补0
            gmtHours = (Array(numLength).join(0) + gmtHours).slice(-numLength);
            cookies.set('timezone', 'GMT' + sign + gmtHours + ':00', { domain: '.midea.com' });
            state.locale = locale;
        },
        getSystemSwitchs(state, switchs) {
            state.switchs = switchs;
        },
        getVue2MicroRoot(state, vue2MicroRoot) {
            state.vue2MicroRoot = vue2MicroRoot;
        },
        getLotsUIEventInstance(state, lotsUIEventInstance) {
            state.lotsUIEventInstance = lotsUIEventInstance;
        },
        getContractManageParams(state, contractManageParams) {
            state.contractManageParams = contractManageParams;
        },
        updateRegistrationReprotList(state, registrationReprotList) {
            state.registrationReprotList.push(registrationReprotList);
        },
        updateCustomerWhiteList(state, list) {
            state.customerWhiteList.push(list);
        },
        updateIflowPage(state, info) {
            state.iflowPage = info;
        },
        updateHomeSearchInput(state, val) {
            state.homeSearchInput = val;
        },
        updateHomePageParams(state, val) {
            state.homePageParams = val;
        },
        updateUserRoleList(state, list) {
            state.userRoleList = list;
        },
        updateHomeContractCode(state, list) {
            state.homeContractCode = list;
        },
        ...tenant.mutations,
        ...Msg.mutations,
        ...uploadList.mutations,
        ...App.mutations
    },
    actions: {
        /**
         * 初始化系统
         * @param {*} param0
         */

        initTenantsData({ dispatch, commit, state }) {
            const params = {
                listFlag: 1,
                pageNo: 1,
                pageSize: 10,
                syncTenant: 1
            };
            return Promise.all([findCurrUser(), getUserAllTenants(params)]).then(res => {
                if (+res[0].code === 0 && +res[1].code === 0) {
                    commit('updateUserInfo', res[0].data);
                    if (!res[1].data.currentTenant) {
                        !containsAnyKeywordIndexOf(window.location.href, whiteList) && alertErrorAndLogout('不存在默认租户，请联系管理员重新登录!');
                        return false;
                    }
                    commit('updateTenant', res[1].data.tenants ? res[1].data.tenants : {});
                    commit('updateCurrenTenant', res[1].data.currentTenant ? res[1].data.currentTenant : {});
                    return dispatch('initResources');
                } else {
                    checkAndAlertError(res[0]);
                    checkAndAlertError(res[1]);
                }
            });
        },

        initMicroSystem({ commit }) {
            const data = window.microApp.getData();
            commit('updateUserInfo', data.user);
            commit('updateTenant', data.tenantInfo);
            commit('updateCurrenTenant', data.currentTenant);
            commit('updateAppList', data.appList);
            commit('updateCurrentApplicationCode', data.applicationCode);
            commit('getBtnPermissions', data.btnPermissions);
            commit('updateAuthority', data.authority);
            commit('getVue2MicroRoot', data.vue2MicroRoot);
            commit('getLotsUIEventInstance', data.lotsUIEventInstance);
        },

        initResources({ dispatch, commit, state }) {
            const applicationCode = 'APP202304140001';
            // const applicationCode = 'APP201904250002';
            commit('updateCurrentApplicationCode', applicationCode);
            // 接入配置中心
            // const SwitchStatus = false;
            // if (SwitchStatus) {
            //     applicationCode && fetchSystemSwitch(applicationCode).then(res => {
            //         if (res.code === '0') {
            //             commit('getSystemSwitchs', res.data);
            //         }
            //     });
            // }

            return getAllResources({
                userCode: state.user.userCode,
                applicationCode: state.currentApplicationCode,
                tenantCode: state.currentTenant.tenantCode
                // eslint-disable-next-line complexity
            }).then(resData => {
                if (resData && +resData.code === 0) {
                    const btnPermissions = getResourceIds(resData.data);
                    commit('getBtnPermissions', btnPermissions);
                    commit('updateAuthority', resData.data[0] && resData.data[0].subResources && resData.data[0].subResources.length ? resData.data[0].subResources : []);
                    if (resData.data && resData.data.length === 0) {
                        !containsAnyKeywordIndexOf(window.location.href, whiteList) && Message.error({
                            message: '您没有菜单权限',
                            showClose: true
                        });
                        return false;
                    }
                    const userCode = state.user.userCode.toLocaleLowerCase();
                    if (userCode.indexOf('hc') === 0 || userCode.indexOf('hp') === 0) {
                        return querySupplierInFoBySupplierCode(state.user.userCode).then(resSupplier => {
                            if (resSupplier && +resSupplier.code === 0) {
                                commit('updateSupplier', resSupplier.data);
                            }
                            return resSupplier.data;
                        });
                    }
                    return true;
                } else {
                    Message.error(resData.msg);
                    return false;
                }
            });
        },
        UPDATE_LANG({ commit, state }) {
            const langSettings = lang.initLanguage(state.locale);
            commit('updateLang', langSettings);
            return langSettings;
        },
        ...tenant.actions,
        ...Msg.actions,
        ...uploadList.actions,
        ...App.actions
    }
};
